import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isRegister, setIsRegister] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const endpoint = isRegister ? '/api/register' : '/api/login';
      const response = await axios.post(`${API_URL}${endpoint}`, formData);
      
      onLogin(response.data.user, response.data.token);
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="animated-background">
        {[...Array(8)].map((_, i) => (
          <div key={i} className={`floating-card card-${i + 1}`}>
            <div className="card-inner">
              <div className="card-front"></div>
              <div 
                className="card-back" 
                style={{ 
                  backgroundImage: `url(${API_URL}/cards/back.jpg)` 
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="login-content">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-header">
            <div className="card-emoji">🃏</div>
            <h2>{isRegister ? 'Registrati' : 'Accedi'} a Fantavaro</h2>
            <p>Aste in tempo reale delle carte AVARE</p>
          </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <div className="form-group">
          <label htmlFor="username">Nome utente</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Inserisci il tuo nome utente"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Inserisci la tua password"
            required
          />
        </div>
        
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Attendere...' : (isRegister ? 'Registrati' : 'Accedi')}
        </button>
        
        <button 
          type="button" 
          className="btn btn-secondary"
          onClick={() => setIsRegister(!isRegister)}
        >
          {isRegister ? 'Hai già un account? Accedi' : 'Serve un account? Registrati'}
        </button>
        
        {isRegister && (
          <p style={{ marginTop: '12px', fontSize: '12px', textAlign: 'center', opacity: 0.8 }}>
            I nuovi account iniziano con <span className="patapizza-icon"></span>10.000 patapizze.
          </p>
        )}
        </form>
      </div>
    </div>
  );
}

export default Login;